// extracted by mini-css-extract-plugin
export default {"filterContainer":"TemplatesFilters_filterContainer__-aZTa","searchField":"TemplatesFilters_searchField__MBPYY"};